// extracted by mini-css-extract-plugin
module.exports = {"root":"product-price_root__21VGj","priceSymbol":"product-price_priceSymbol__1PXrH"};